<template>
    <div class="login-wrap">
        <div class="ms-login">
            <div class="ms-title">农合联金融服务平台
                <div class="swichDiv" :class="{'swichDivIco1':isActive,'swichDivIco2':!isActive}" @click="swichLogin"></div>
            </div>
            <el-form v-if="isActive" :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="username">
                    <el-input v-model="param.username" placeholder="用户名">
                        <template #prepend>
                            <el-button icon="el-icon-user"></el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        type="password"
                        placeholder="密码"
                        v-model="param.password"
                        @keyup.enter="submitForm()"
                    >
                        <template #prepend>
                            <el-button icon="el-icon-lock"></el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()">登录</el-button>
                </div>
            </el-form>
            <div v-else class="qcCodeDiv" ref="qrCodeUrl" @click="refreshQcCode"></div>
        </div>
    </div>
</template>

<script>
import apis  from "../api/index";
import md5 from 'js-md5';
import QRCode from 'qrcodejs2';
export default {
    data() {
        return {
            isActive:true,
            param: {
                username: "",
                password: ""
            },
            rules: {
                username: [
                    { required: true, message: "请输入用户名", trigger: "blur" }
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" }
                ]
            },
            scanObj:null,
            myInterval:null
        };
    },
    created() {
        this.$store.commit("clearTags");
    },
    methods: {
        // 切换用户名登录还是密码登录
        swichLogin(){
            this.isActive = !this.isActive
            if(!this.isActive){
                this.creatQrCode()
            }else{
                if(this.myInterval){
                    clearInterval(this.myInterval)
                    this.myInterval = null
                }
            }
        },
        // 刷新二维码
        refreshQcCode(){
            this.creatQrCode()
        },
        // 创建二维码
        creatQrCode() {
            let that = this
            apis.getScanLoginParam().then(res => {
                that.scanObj = res
                that.$nextTick(() => {
                    that.$refs.qrCodeUrl.innerHTML = ''
                    let qrcode = new QRCode(that.$refs.qrCodeUrl, {
                        text: that.scanObj.scanUrl, // 需要转换为二维码的内容
                        width: 174,
                        height: 174,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        correctLevel: QRCode.CorrectLevel.H
                    })  
                    that.isHasScanCode() 
                });
            })
        },
        isHasScanCode(){
            let that = this
            if(that.myInterval){
                clearInterval(that.myInterval)
                that.myInterval = null
            }
            if(that.scanObj){
                that.myInterval = window.setInterval(() => {
                    setTimeout(() => {
                        let param = {
                            scanId:that.scanObj.scanId
                        }
                        apis.getScanInfo(param).then(res => {
                            if(res){
                                clearInterval(that.myInterval)
                                that.myInterval = null
                                localStorage.setItem("token", res.token)
                                apis.qcLogin().then(res2 => {
                                    if(res2){
                                        if(res2 === '该用户不存在，请联系管理员'){
                                            that.$message.error("该用户不存在，请联系管理员");
                                        }else if(res2=== '登录异常，请联系管理员'){
                                            that.$message.error("登录异常，请联系管理员");
                                        }else{
                                            // that.$message.success("扫码成功,正在登录中...");
                                            that.isActive = true
                                            localStorage.setItem("token", res2.token);
                                            localStorage.setItem("user_info",JSON.stringify(res2))
                                            that.$store.commit("setUserName", res2.UserName);
                                            that.$store.commit("setUserIco", res2.HeadImg);
                                            // this.$message.success("登录成功");
                                            that.$router.push("/");
                                        }
                                    }
                                })
                                
                            }
                        })
                    }, 1)
                }, 2000);
            }
        },
        submitForm() {
            this.$refs.login.validate(valid => {
                if (valid) {
                    let pw = md5(this.param.password)
                    let para = {
                        UserName:this.param.username,
                        Password:pw
                    }
                    this.$store.commit("clearMenus");
                    localStorage.removeItem("user_info");
                    localStorage.removeItem("token")
                    // apis.login()
                    apis.login(para).then(res => {
                        if(res){
                        if(res === '用户名或者密码错误'){
                            this.$message.error("用户名或者密码错误");
                        }else if(res === '用户名或者密码不能为空'){
                            this.$message.error("用户名或者密码不能为空");
                        }else if(res=== '登录异常，请联系管理员'){
                            this.$message.error("登录异常，请联系管理员");
                        }else{
                            localStorage.setItem("token", res.token);
                            localStorage.setItem("user_info",JSON.stringify(res))
                            this.$store.commit("setUserName", res.UserName);
                            this.$store.commit("setUserIco", res.HeadImg);
                            // this.$message.success("登录成功");
                            this.$router.push("/");
                        }
                    }else{
                        this.$message.error("登录失败"); 
                    }
                    });
                } else {
                    this.$message.error("请输入用户名和密码");
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
.login-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url(../assets/img/login-bg.jpg);
    background-size: 100%;
}
.login-wrap .ms-title {
    width: 100%;
   
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #409eff;
    border-bottom: 1px solid #ddd;
}
.login-wrap .ms-login {
    position: absolute;
    left: 80%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}
.login-wrap .ms-content {
    padding: 30px 30px;
}
.login-wrap .login-btn {
    text-align: center;
}
.login-wrap .login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}
.login-wrap .login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}

.login-wrap .swichDiv{
    height: 50px;
    width: 50px;
    float: right;
    cursor: pointer;
}

.login-wrap .swichDivIco1{
    background: url(../assets/img/swich.png) 50px 50px;
}
.login-wrap .swichDivIco2{
    background: url(../assets/img/swich1.png) 50px 50px;
}

.login-wrap .qcCodeDiv{
    display: inline-block;
    height: 174px;
    width: 290px;
    padding: 30px;
    text-align: center;
    cursor: pointer;
}

.login-wrap .qcCodeDiv /deep/ img{
    width: 174px!important;
    height: 174px!important;
    background-color: #fff!important; 
    padding: 6px!important; 
    box-sizing: border-box!important;
    margin:0px auto;
}
</style>
